import { Typography } from "@mui/material";
import { DocumentHyperlink } from '../../../components/DocumentHyperlink';
import { PopupMessage } from '../../../components/PopupMessage';
import { PdfLinkStyle } from "./../styled";

export const Disclaimer = ({ onClick }: { onClick: () => void }) => {
  return (
    <PopupMessage onClose={onClick} title="JDA Reports Details">
      <Typography data-automation="JDA-disclaimer-paragraph-1" sx={{ mb: 2 }}>
        One of the services BCMEA provided in the past are Physical Demands Analysis reports.
        PDA reports are used by the claims management department as well as member companies
        as a resource for assessing return to work or accommodation requests.
        The reports will also be utilized by the Training department to assist in the
        curriculum development process and ensure appropriate updates to existing programs.
      </Typography>
      <DocumentHyperlink
        dataAutomation='PDA-pdf'
        link='#'
        title='PDA'
        styles={PdfLinkStyle}
      />
      <Typography data-automation="JDA-disclaimer-paragraph-2" sx={{ mb: 2 }}>
        Actual full physical demand report (PDA) for the specified job.
      </Typography>
      <DocumentHyperlink
        title='MD Summary'
        link='#'
        dataAutomation='MD-pdf'
        styles={PdfLinkStyle}
      />
      <Typography data-automation="JDA-disclaimer-paragraph-3">
        Pull out section from the PDA report and has been saved separately for ease of use.
        This is a medical summary specific to the job. Its purpose is to be given to the
        Medical practitioner to fill out and send back.
        This will help alleviate the issue of a lack of understanding by the practitioner as to what
        the job physically entails and to provide you with more specific details as to the direct job
        related tasks that the worker is unable to perform.
      </Typography>
    </PopupMessage>
  );
}